/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".accent-color[_ngcontent-%COMP%]{color:#555}.warn-color[_ngcontent-%COMP%]{color:#f44336}.aec-i[_ngcontent-%COMP%]{background:url(/assets/images/bike.png) 0 0/contain no-repeat;width:120px;height:65px;margin:20px auto}.full[_ngcontent-%COMP%]{width:100%}.full[_ngcontent-%COMP%]     .mat-input-element{color:#141414}.full[_ngcontent-%COMP%]     .mat-form-field-label{color:#141414}.center[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
